import WPAPI from "wpapi";

import { v4 as uuidv4 } from 'uuid';

export class Session {
    constructor(playgroundInstance) {
        this.playgroundInstance = playgroundInstance;

        this.host = location.protocol + "//" + location.hostname;

        this.wp = new WPAPI({ endpoint: `${this.host}/wp-json/` });
        this.wp.playgrounds = this.wp.registerRoute('wp/v2', '/playground/(?P<id>)');
        this.wp.tests = this.wp.registerRoute('myplugin/v1', '/playground/(?P<id>)');

        window.share = this.share.bind(this);
        window.getStory = this.getStory.bind(this);
    }

    getStory = function (slug, callback) {
        this.wp.playgrounds().slug(slug).then((story) => {
            console.log("GET_STORY", story);
            callback(story);
        })
    }

    share = function (title, descrition, mode, callback) {
        const currentCode = window.currentCodeEditor != null ? window.currentCodeEditor.getValue() : "";

        var currentWorkspace = mode == 'javascript' ? currentCode : this.playgroundInstance.getWorkspace()
        //var editor = CodeMirror.fromTextArea(document.getElementById("codeeditor"));
        //var codice = editor.getValue();
        

        const randomID = uuidv4();
        this.wp.tests().create({
            // "title" and "content" are the only required properties
            title: title,
            excerpt: descrition,
            slug: 'story-' + randomID,
            mode: mode,
            xml: currentWorkspace,
            
            // Post will be created as a draft by default if a specific "status"
            // is not specified
            status: 'publish'
        }).then(function (response) {
            // "response" will hold all properties of your newly-created post,
            // including the unique `id` the post was assigned on creation
            callback(response);
        })
    }
}